/** @jsx jsx */
/* eslint-disable no-magic-numbers */
/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable jsx-control-statements/jsx-use-if-tag */
/* eslint-disable react/jsx-pascal-case */

import React from 'react'
import { jsx } from 'theme-ui'
import { connect } from 'react-redux'
import { getComponentById } from '../../redux/component/component-selectors'
import { Container } from '../helpers/react'

const alphabet = ['0-9', ...'abcdefghijklmnopqrstuvwxyz'.split('')]

const ProviderList = ({ providers }) => {
  const backToTopScroll = (e) => {
    e.preventDefault()
    const element = document.getElementById('topScroll')
    element.scrollIntoView({ behavior: 'smooth' })
  }

  const filterScroll = (e, id) => {
    e.preventDefault()
    const element = document.getElementById(id)
    element.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        flexWrap: 'wrap',
        backgroundColor: '#eeeeee',
        pb: 48,
      }}
      id='topScroll'
    >
      <div sx={{ backgroundColor: '#ffffff', width: '100%' }}>
        <Container>
          <ul
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              width: '100%',
              listStyle: 'none',
              paddingLeft: 0,
            }}
          >
            {alphabet.map((letter, index) => {
              const pattern = new RegExp('[' + letter + ']', 'i')
              const currentProviders = providers.filter((client) => client.name[0].match(pattern))
              return (
                <li key={index}>
                  {currentProviders.length > 0 ? (
                    <button
                      sx={{
                        ...scrollLinkStylesActive,
                        background: 'none',
                        border: 'none',
                        outline: 'none',
                        color: '#ADAFB3',
                        cursor: 'pointer',
                      }}
                      onClick={(e) => filterScroll(e, `${letter}-scroll`)}
                    >
                      {letter.toUpperCase()}
                    </button>
                  ) : (
                    <span sx={scrollLinkStyles}>{letter.toUpperCase()}</span>
                  )}
                </li>
              )
            })}
          </ul>
        </Container>
      </div>
      <Container sx={{ width: '100%' }}>
        <div
          sx={{
            width: '100%',
          }}
        >
          {alphabet.map((letter, index) => {
            const pattern = new RegExp('[' + letter + ']', 'i')
            const currentProviders = providers.filter((client) => client.name[0].match(pattern))
            return (
              <div
                key={index}
                id={`${letter}-scroll`}
                sx={{
                  marginTop: 'md',
                  padding: '0 10px',
                }}
              >
                <div sx={{ marginBottom: 'sm' }}>
                  <span
                    sx={{
                      fontSize: 'xxl',
                      marginRight: 6,
                      fontWeight: 'bold',
                      fontFamily: 'heading',
                    }}
                  >
                    {letter.toUpperCase()}
                  </span>{' '}
                  <button
                    sx={{
                      background: 'none',
                      border: 'none',
                      outline: 'none',
                      color: '#6D6F73',
                      fontSize: 'xs',
                      cursor: 'pointer',
                      fontFamily: 'body',
                      textDecoration: 'underline',
                    }}
                    onClick={(e) => backToTopScroll(e)}
                  >
                    back to top
                  </button>
                </div>
                <div
                  sx={{
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'flex-start',
                    flexWrap: 'wrap',
                    width: '100%',
                  }}
                >
                  {currentProviders.map((client, subindex) => {
                    return (
                      <div
                        key={subindex}
                        sx={{
                          display: 'flex',
                          alignItems: 'space-between',
                          justifyContent: 'center',
                          width: ['calc(50% - 12px)', '152px', '167px'],
                          background: '#ffffff',
                          padding: '16px',
                          marginRight:
                            Number(subindex + 1) % 2 === 0
                              ? ['0', 'md', '46px']
                              : ['md', 'md', '46px'],
                          marginBottom: 'md',
                          boxSizing: 'border-box',
                          alignSelf: 'stretch',
                        }}
                      >
                        <div
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <div
                            sx={{
                              height: '75px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src={client.imageUrl}
                              alt={client.name}
                              sx={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                              }}
                            />
                          </div>
                          <p
                            sx={{
                              marginTop: 'sm',
                              marginBottom: 0,
                              fontSize: 'sm',
                              textAlign: 'center',
                              wordBreak: 'break-word',
                            }}
                          >
                            {client.name}
                          </p>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </div>
  )
}

const scrollLinkStyles = {
  width: '40px',
  fontSize: 'md',
  lineHeight: '36px',
  textAlign: 'center',
  margin: '5px',
  display: 'inline-block',
  textDecoration: 'none',
}

const scrollLinkStylesActive = {
  ...scrollLinkStyles,
  display: 'inline',
  border: 'none',
  cursor: 'pointer',
  color: '#24262A',
}

export default connect((state: any, props: any) => {
  const { sys } = props
  return {
    providers: getComponentById(state, sys.id)?.providers,
  }
})(ProviderList)
